import useIsMobileMixin from 'StudentNetwork/react/useIsMobileMixin';
import { MAIN_APP_SCROLLABLE_ELEMENT_SELECTOR } from 'ScrollHelper';

export function useLessonPlayerScrollContainer(): Element | null {
    const { isMobile } = useIsMobileMixin();

    return isMobile
        ? document.querySelector(MAIN_APP_SCROLLABLE_ELEMENT_SELECTOR)
        : document.querySelector('show-frames-player .scroll-wrapper');
}
